var map = {
	"./3d-cube-scan.svg": 3222,
	"./Effect.svg": 4896,
	"./Empty Icon.svg": 8897,
	"./Logo.svg": 2794,
	"./Rectangle 3274.svg": 9796,
	"./active.svg": 7177,
	"./add.svg": 6848,
	"./arrow-down.svg": 23,
	"./arrow-downD.svg": 8489,
	"./arrow-downM.svg": 7600,
	"./arrow-left.svg": 3080,
	"./arrow-leftD.svg": 1108,
	"./arrow-rightD.svg": 2537,
	"./arrow-up.svg": 4152,
	"./bank.svg": 1985,
	"./barcode.svg": 9017,
	"./box-2.svg": 2547,
	"./box-search.svg": 8903,
	"./box-tick.svg": 4888,
	"./box.svg": 2018,
	"./boxD.svg": 1746,
	"./boxS.svg": 6413,
	"./bubble.svg": 8105,
	"./cake.svg": 5743,
	"./calendar.svg": 4385,
	"./call.svg": 3815,
	"./card-tick.svg": 2229,
	"./category-2.svg": 4634,
	"./cloud-connection.svg": 2819,
	"./code-circle.svg": 1661,
	"./coin.svg": 304,
	"./cpu.svg": 5063,
	"./cpuB.svg": 6279,
	"./cpuS.svg": 7222,
	"./diagram.svg": 3590,
	"./diamonds.svg": 584,
	"./discover.svg": 4670,
	"./document-text.svg": 3952,
	"./driver.svg": 4825,
	"./edit.svg": 2663,
	"./edits.svg": 566,
	"./export.svg": 2557,
	"./forbidden-2.svg": 4603,
	"./forbidden-3.svg": 2634,
	"./forbidden.svg": 1066,
	"./global.svg": 9918,
	"./gps.svg": 4565,
	"./import.svg": 4512,
	"./info-circle.svg": 4232,
	"./internet-empty-logo.svg": 9244,
	"./key.svg": 2144,
	"./level.svg": 8859,
	"./location.svg": 670,
	"./messages-3.svg": 4903,
	"./moon.svg": 2148,
	"./note-2.svg": 30,
	"./note.svg": 8539,
	"./noted.svg": 8365,
	"./notification.svg": 8910,
	"./password-check.svg": 1735,
	"./profile-2user-dark.svg": 5543,
	"./profile-2user.svg": 1502,
	"./profile-circle.svg": 3987,
	"./scan-barcode.svg": 8507,
	"./search-normal.svg": 7609,
	"./search-normal2.svg": 8569,
	"./search-status.svg": 3798,
	"./setting-2.svg": 3900,
	"./setting-3.svg": 3613,
	"./setting-4.svg": 5298,
	"./setting.svg": 8893,
	"./sidebar-active.svg": 3916,
	"./slash.svg": 5370,
	"./sms-search.svg": 2303,
	"./sms-tracking.svg": 408,
	"./sms.svg": 3306,
	"./star.svg": 6311,
	"./tick-circle.svg": 3421,
	"./tick.svg": 6304,
	"./timer.svg": 7554,
	"./transaction-minus.svg": 2838,
	"./trash.svg": 1571,
	"./trashR.svg": 8891,
	"./truck.svg": 3044,
	"./user-edit.svg": 911,
	"./user-tick.svg": 2728,
	"./user.svg": 8610,
	"./userF.svg": 1616,
	"./wallet.svg": 2248
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 7053;